import { ApolloClient, InMemoryCache } from "@apollo/client";
import { config } from "../config";

const {
  CONTENTFUL_API_BASE_URL: apiUrl,
  CONTENTFUL_SPACE_ID: spaceId,
  CONTENTFUL_SPACE_ENVIRONMENT: environment,
  CONTENTFUL_API_TOKEN: token,
} = config;

export const contentfulClient = new ApolloClient({
  uri: `${apiUrl}/content/v1/spaces/${spaceId}/environments/${environment}`,
  headers: {
    authorization: `Bearer ${token}`,
  },
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // Two queries (GET_PROGRAM_PAGE and GET_FORM_CONFIG) both select the
          // CppFormLayout at Query.cppFormLayout, and it has no `id` to
          // normalize on. Without a merge policy, Apollo warns ("Cache data may
          // be lost when replacing the cppFormLayout field…") and REPLACES
          // rather than merges, so fields from one query (e.g. formConfig or
          // isEmbeddedHtml) can be dropped. merge:true shallow-merges the two
          // partial results into one cache entry per id.
          cppFormLayout: { merge: true },
        },
      },
    },
  }),
});
